import React, { useEffect } from "react";
import * as echarts from "echarts";

interface DepartmentData {
  name: string;
  value: number;
  color: string;
}

interface ChartItem {
  month: string;
  departments: DepartmentData[];
}

const EngagementBar = ({ chartData }: any) => {
    const isInsights = window.location.pathname.startsWith("/insights");

  useEffect(() => {
    const data = chartData || [];
    console.log(data, "EngagementBar chartData");
    // Create a bar chart
    const chart = echarts.init(
      document.getElementById("bar-chart") as HTMLDivElement
    );

    // Extract department names dynamically
    // const departmentNames =
    //   data[0]?.departments.map((department: any) => department.name) || [];

    // const options = {
    //   xAxis: {
    //     type: "category",
    //     data: data.map((item: ChartItem) => item.month),
    //     axisLabel: {
    //       rotate: 45,
    //     },
    //   },
    //   yAxis: {
    //     type: "value",
    //     min: 1,
    //     max: 8, // Set the maximum value of the y-axis as needed
    //     interval: 1,
    //   },
    //   series: departmentNames.map((department: any) => ({
    //     name: department,
    //     type: "bar",
    //     data: data.map((item: ChartItem) => {
    //       const depData = item.departments.find(
    //         (dep) => dep.name === department
    //       );
    //       return depData ? depData.value : 0;
    //     }),
    //     itemStyle: {
    //       color: (item: any) => {
    //         const depData = data
    //           .find((d: any) => d.month === item.name)
    //           ?.departments.find((dep: any) => dep.name === department);
    //         return depData ? depData.color : "#000000"; // Default color if no color is found
    //       },
    //     },
    //   })),
    // };

    const options = {
      grid: {
        left: "0%",
        right: "5%",
        bottom: "2%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yAxis: {
        type: "value",
        min: 0, // Set minimum value
        max: 8, // Set maximum value
        // interval: 50,
        //type: "value",
      },
      series: [
        {
          data: data,
          type: "bar",
          barWidth: 15,
          itemStyle: { color: "#9EC756", barBorderRadius: [5, 5, 0, 0] },
        },
      ],
    };

    // Set chart options
    chart.setOption(options);

    const chartElement = document.getElementById("bar-chart") as HTMLDivElement;
    const resizeObserver = new ResizeObserver(() => {
      chart.resize();
    });
    if (chartElement) resizeObserver.observe(chartElement);

    // Cleanup on unmount
    return () => {
      resizeObserver.disconnect();
      chart.dispose();
    };
  }, [chartData]);

  return (
    <div
      id="bar-chart"
      style={{
        width: "100%",
        height: isInsights ? "257px" : "400px",
        margin: "0 !important",
        cursor: "not-allowed !important",
      }}
    ></div>
  );
};

export default EngagementBar;
